<app-navbar title="Wydarzenia Piloci">
	<button class="btn btn-warning me-2" (click)="filtersOpen()">
		<i class="fas fa-filter"></i>
	</button>
</app-navbar>

<div id="loader" *ngIf="loader"><span class="spinner-border spinner-grow-lg"></span></div>

<app-tourist-guides-reward-filters
	userFilters="touristGuidesReward"
	[touristGuides]="touristGuides"
	[calculated]="parameters.calculated"
	(selected)="filtersSelected($event)"
></app-tourist-guides-reward-filters>

<table class="table table-striped table-hover">
	<thead class="table-dark">
		<tr>
			<th class="align-middle">
				<span (click)="setSort('tourist_guide')" [ngClass]="{ sortBy: 'tourist_guide' === sortKey }"
					>Wydarzenie</span
				>
			</th>
			<th class="align-middle">
				<span (click)="setSort('date_from')" [ngClass]="{ sortBy: 'date_from' === sortKey }">Data od</span>
			</th>
			<th class="align-middle">
				<span (click)="setSort('date_to')" [ngClass]="{ sortBy: 'date_to' === sortKey }">Data do</span>
			</th>
			<th class="align-middle">
				<span (click)="setSort('value')" [ngClass]="{ sortBy: 'value' === sortKey }">Stawka</span>
			</th>
			<th class="align-middle">
				<span (click)="setSort('value')" [ngClass]="{ sortBy: 'value' === sortKey }">Wypłacono</span>
			</th>
			<th class="align-middle">
				<span (click)="setSort('paymentDay')" [ngClass]="{ sortBy: 'paymentDay' === sortKey }"
					>Termin płatności</span
				>
			</th>
			<th class="align-middle">Zatrudnienie</th>
			<th class="align-middle">
				<span (click)="setSort('paymentDayRest')" [ngClass]="{ sortBy: 'paymentDayRest' === sortKey }"
					>Forma Płatności</span
				>
			</th>
			<th class="align-middle">Komentarz</th>
			<th class="align-middle">Opłaty programowe</th>
			<th class="align-middle">Waluta</th>
		</tr>
	</thead>
	<tbody>
		<tr *ngFor="let item of data" [ngClass]="{ salaryComments: item.salary_comments }">
			<td>
				<abbr title="{{ item.salary_comments }}">
					{{ item.tourist_guide }} / {{ item.name }} / {{ item.vehicle_name }} - {{ item.typeName }}
				</abbr>
			</td>
			<td>{{ item.date_from | formatDateTime }}</td>
			<td>{{ item.date_to | formatDateTime }}</td>
			<td class="text-end align-midle">
				<input
					type="number"
					step="0.01"
					class="form-control"
					name="tax"
					[(ngModel)]="item.tax"
					[disabled]="!item.editable"
				/>
			</td>
			<td class="text-end align-midle">
				<input
					type="number"
					step="0.01"
					class="form-control"
					name="salary"
					[(ngModel)]="item.salary"
					[disabled]="!item.editable"
				/>
			</td>
			<td class="text-end align-midle">
				<input
					type="date"
					class="form-control"
					name="paymentDay"
					[(ngModel)]="item.paymentDay"
					[disabled]="!item.editable"
				/>
			</td>
			<td class="text-end align-midle">
				<select
					type="text"
					class="form-select"
					name="employment"
					[(ngModel)]="item.employment"
					[disabled]="!item.editable"
				>
					<option [value]="item.id" *ngFor="let item of employment">{{ item.name }}</option>
				</select>
			</td>
			<td class="text-end align-midle">
				<select
					type="text"
					class="form-select mb-2"
					name="paymentMethod"
					[(ngModel)]="item.paymentMethod"
					[disabled]="!item.editable"
				>
					<option [value]="item.id" *ngFor="let item of paymentMethods">{{ item.name }}</option>
				</select>
				<abbr title="{{ item.userVerifyHistoryLast?.user }} {{ item.userVerifyHistoryLast?.date }}">
					<button
						class="btn"
						[ngClass]="{ 'btn-success': item.payment, 'btn-danger': !item.payment }"
						(click)="payment(item)"
					>
						Wypłacono
					</button>
				</abbr>
			</td>
			<td class="text-end align-midle">
				<abbr title="{{ item.description }}">
					<input
						type="text"
						class="form-control mb-2"
						name="description"
						[(ngModel)]="item.description"
						[disabled]="!item.editable"
					/>
				</abbr>
				<button class="btn btn-primary mb-2" *ngIf="!item.editable" (click)="item.editable = true">
					Edytuj
				</button>
				<button class="btn btn-danger mb-2" *ngIf="item.editable" (click)="save(item)">Zapisz</button>
			</td>
			<td>
				<input
					type="number"
					step="0.01"
					class="form-control mb-2"
					name="value"
					[(ngModel)]="item.value"
					[disabled]="item.calculated || !item.editable"
				/>
				<abbr title="{{ item.userVerifyHistoryLast?.user }} {{ item.userVerifyHistoryLast?.date }}">
					<button
						class="btn"
						[ngClass]="{ 'btn-success': item.verified, 'btn-danger': !item.verified }"
						(click)="verified(item)"
					>
						Wynagrodzenie
					</button>
				</abbr>
			</td>
			<td>
				<select
					type="text"
					class="form-select mb-2"
					name="currency"
					[(ngModel)]="item.currency"
					[disabled]="item.calculated || !item.editable"
				>
					<option value="">(Brak)</option>
					<option [value]="item.id" *ngFor="let item of currencies">{{ item.name }}</option>
				</select>
				<abbr title="{{ item.userCalculatedHistoryLast?.user }} {{ item.userCalculatedHistoryLast?.date }}">
					<button
						class="btn"
						[ngClass]="{ 'btn-success': item.calculated, 'btn-outline-danger': !item.calculated }"
						(click)="calculated(item)"
					>
						Rozliczony
					</button>
				</abbr>
			</td>
		</tr>
	</tbody>
</table>
